import React, { useCallback, useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  CardHeader,
  Collapse,
} from "reactstrap"
import CategoryProductsTable from "./Components/CategoryProductsTable"
import classNames from "classnames"
import { DeleteCategory } from "pages/admin/Categories/Modals"
import { useTranslation } from "react-i18next"

export type Product = {
  id: string
  name: string
  image: string
  couponBased: boolean
  price: number
  size: string
  stock: number
  featured: boolean
  status: string
}

const category = {
  id: "1",
  categoryName: "Category 1",
  productCount: 10,
  createdAt: "2022-01-01",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam nec metus vel ante feugiat facilisis. Nullam nec metus vel ante feugiat facilisis, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam nec metus vel ante feugiat facilisis. Nullam nec metus vel ante feugiat facilisis.",
  productList: [
    {
      id: "1",
      name: "Product 1",
      image: "https://placehold.co/30x30/png",
      couponBased: true,
      price: 10,
      size: "Gallon",
      stock: 20,
      featured: true,
      status: "Active",
    },
    {
      id: "2",
      name: "Product 2",
      image: "https://placehold.co/30x30/png",
      couponBased: true,
      price: 10,
      size: "Gallon",
      stock: 20,
      featured: true,
      status: "Active",
    },
    {
      id: "3",
      name: "Product 3",
      image: "https://placehold.co/30x30/png",
      couponBased: true,
      price: 10,
      size: "Gallon",
      stock: 20,
      featured: true,
      status: "In Active",
    },
  ],
}
const CategoryDetails = () => {
  const [checkedProducts, setCheckedProducts] = useState<Product[]>([])
  const [products, setProducts] = useState<Product[]>([])
  const [openFirstAccordion, setOpenFirstAccordion] = useState<string>("0")
  const [showDeleteCategoryModal, setShowDeleteCategoryModal] = useState(false)

  const { t } = useTranslation()

  useEffect(() => {
    setProducts(category.productList)
  }, [])

  const isAllChecked = useMemo(
    () => products.length > 0 && checkedProducts.length === products.length,
    [products, checkedProducts]
  )
  const toggleAllProducts = useCallback(() => {
    setCheckedProducts(isAllChecked ? [] : category.productList)
  }, [isAllChecked, category.productList])

  const togglecheckedProductHandler = useCallback((product: Product) => {
    setCheckedProducts(prev =>
      prev.includes(product)
        ? prev.filter(p => p !== product)
        : [...prev, product]
    )
  }, [])

  const toggleActiveProduct = (product: Product) => {
    console.log(product)
    console.log(checkedProducts)
    setProducts(prev =>
      prev.map(c =>
        c.id === product.id
          ? {
              ...c,
              status: product.status === "Active" ? "In Active" : "Active",
            }
          : c
      )
    )
  }
  const handleToggle = (event: any) => {
    const id = event.targetValue as string // ✅ ده هو المفتاح
    setOpenFirstAccordion(openFirstAccordion === id ? "" : id)
  }

  return (
    <div className="page-content d-flex flex-column">
      <div className="container-fluid p-0">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <Breadcrumbs
            title={t("dashboard_dashboard")}
            breadcrumbItem={t("categories_categories")}
            subBreadcrumbItem={`${category.categoryName}`}
          />
          <div className="d-flex gap-3 flex-wrap">
            <button className="btn bg-gradiant-blue border-0 text-white">
              {t("categories_editCategory")}
            </button>
            <button
              onClick={() => setShowDeleteCategoryModal(true)}
              className="btn btn-outline-danger"
            >
              {t("categories_deleteCategory")}
            </button>
          </div>
        </div>
        <div className="container-fluid">
          <Card className="shadow-md rounded-3 py-2">
            <CardHeader className="bg-transparent d-flex justify-content-between">
              <div>
                <h5 className="card-title m-0">{category.categoryName}</h5>
                <p className="card-text m-0">
                  {t("common_createdAt")}: {category.createdAt}
                </p>
              </div>
              <div className="d-flex">
                <h5 className="card-title mx-2">
                  {t("categories_productCount")}
                </h5>
                <p className="card-text ">
                  {category.productCount} {t("categories_products")}
                </p>
              </div>
            </CardHeader>
            <CardBody className="py-1">
              <p className="card-text m-0">{category.description}</p>
            </CardBody>
          </Card>
          <div className="accordion shadow-md rounded-3 p-2" id="accordion">
            <AccordionItem>
              <h2 className="accordion-header" id="headingOne">
                <button
                  className={classNames("accordion-button", "fw-medium", {
                    collapsed: !openFirstAccordion,
                  })}
                  type="button"
                  onClick={() =>
                    setOpenFirstAccordion(
                      openFirstAccordion === "0" ? "1" : "0"
                    )
                  }
                  style={{ cursor: "pointer" }}
                >
                  {t("categories_productList")}
                </button>
              </h2>
              <Collapse
                isOpen={openFirstAccordion === "0"}
                className="accordion-collapse"
              >
                <CategoryProductsTable
                  products={products}
                  toggleAllProducts={toggleAllProducts}
                  togglecheckedProductHandler={togglecheckedProductHandler}
                  isAllChecked={isAllChecked}
                  checkedProducts={checkedProducts}
                  toggleActiveProduct={toggleActiveProduct}
                />
              </Collapse>
            </AccordionItem>
          </div>
        </div>
      </div>

      <DeleteCategory
        isOpen={showDeleteCategoryModal}
        toggle={() => setShowDeleteCategoryModal(!showDeleteCategoryModal)}
      />
    </div>
  )
}

export default CategoryDetails
